import {
    DXP_GET_EXPIRING_CONTENT,
    DXP_GET_EXPIRING_CONTENT_ERROR,
    DXP_EXTEND_EXPIRING_CONTENT,
    DXP_EXTEND_EXPIRING_CONTENT_ERROR,
    DXP_UPDATE_EXPIRING_CONTENT,
    DXP_UPDATE_EXPIRING_CONTENT_ERROR,
    DXP_UPDATE_EXPIRING_CONTENT_BULK,
    DXP_UPDATE_EXPIRING_CONTENT_BULK_ERROR,
    DXP_SELECT_EXPIRING_CONTENT,
} from "../actions/types";

const initialState = {
    selectedContent: null,
    expiringContent: [],
    bulkUpdateError: [],
    isLoading: true,
    success: false,
};

export default function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case DXP_GET_EXPIRING_CONTENT:
            return {
                ...state,
                expiringContent: payload,
                isLoading: false,
                success: true,
            };
        case DXP_UPDATE_EXPIRING_CONTENT_BULK:
            return {
                ...state,
                bulkUpdateError: payload,
                isLoading: false,
                success: true,
            };

        case DXP_SELECT_EXPIRING_CONTENT:
            return {
                ...state,
                selectedContent: payload,
            };

        case DXP_EXTEND_EXPIRING_CONTENT:
        case DXP_UPDATE_EXPIRING_CONTENT:
            return {
                ...state,
                isLoading: false,
                success: true,
            };
        case DXP_GET_EXPIRING_CONTENT_ERROR:
            return {
                ...state,
                expiringContent: payload,
                isLoading: false,
                success: false,
            };
        case DXP_UPDATE_EXPIRING_CONTENT_BULK_ERROR:
            return {
                ...state,
                bulkUpdateError: payload,
                isLoading: false,
                success: false,
            };

        case DXP_EXTEND_EXPIRING_CONTENT_ERROR:
        case DXP_UPDATE_EXPIRING_CONTENT_ERROR:
            return {
                ...state,
                isLoading: false,
                success: false,
            };
        default:
            return state;
    }
}
